import React from 'react';
import { useNavigate } from 'react-router-dom';

const CustomQuoteBanner = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-full max-w-7xl mx-auto p-4">
        <div 
          className="rounded-lg md:rounded-[111px] px-6 md:px-12 py-4 md:py-8 flex flex-col md:flex-row items-center justify-between gap-4 md:gap-8"
          style={{ backgroundColor: '#174568' }}
        >
          {/* Text Content */}
          <div className="flex-1 pr-4">
            <h2 className="text-white text-[15px] text-center md:text-left md:text-2xl lg:text-3xl font-normal leading-relaxed">
              Got a unique project in mind or need a custom quote? We've got you covered
            </h2>
          </div>
          
          {/* CTA Button */}  
          <div className="flex-shrink-0">
            <button 
              onClick={() => navigate('/project-submission')}
              className="bg-transparent border-2 border-white text-white px-4 py-2 md:px-8 md:py-3 rounded-full text-[12px] md:text-lg font-medium hover:bg-white hover:text-[#174568] transition-all duration-300 whitespace-nowrap"
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomQuoteBanner;